var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"info",attrs:{"href":_vm.href,"rel":"noreferrer noopener","target":"_blank"}})}
var staticRenderFns = []

export { render, staticRenderFns }